(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CutoutProUtilService', cutoutProUtilService);

    function cutoutProUtilService(
        blockUI,
        CutoutProAPIService,
        MultipleFileUploadService,
        $window,
        $mdDialog,
        $timeout
    ) {
        async function faceCutout($scope, canvas, cutFace, isPreview = false, object = null) {
            const { imageSelected } = $scope;
            const targetObject = object || imageSelected;

            if (!targetObject) {
                console.error('No target object found for face cutout');
                return;
            }

            const blockUIMessage = cutFace ? 'Cutting Face ✂️' : 'Cutting Background ✂️';
            blockUI.start(blockUIMessage);

            try {
                const response = await CutoutProAPIService.cutoutFace(
                    $scope.apiKeys.cutoutPro,
                    targetObject.imageFile,
                    cutFace,
                    isPreview
                );

                if (cutFace) {
                    targetObject.oldCutoutImageFile = targetObject.imageFile;
                    targetObject.oldRBCOPImageFile = null;
                } else {
                    targetObject.oldRBCOPImageFile = targetObject.imageFile;
                    targetObject.oldCutoutImageFile = null;
                }

                targetObject.imageFile = response;
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response], targetObject);

                console.log('done rendering image in placeholder, removing block UI');
                $scope.$apply(() => blockUI.stop());
            } catch (error) {
                $window.rumReportError(error);
                targetObject.oldCutoutImageFile = null;
                targetObject.oldRBCOPImageFile = null;

                $timeout(() => $scope.$apply());
                blockUI.stop();

                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('CutoutPro Error' + (error.statusText ? ': ' + error.statusText : '!'))
                        .textContent(
                            'There seems to be an error with your Cutout Pro account, so the face could not be cut from the image. Please visit your account on Cutout Pro to correct this.'
                        )
                        .ok('OK!')
                );
            }
        }

        async function addFaceCutoutFilter($scope, canvas, isFaceCutout, object, cleanImageFilters = false) {
            const { selectedImageProperties, bulkEdit, editMode } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedImageProperties;

            if (cleanImageFilters) {
                object.CutoutFace = false;
                object.oldCutoutImageFile = null;

                object.removeBackgroundCOP = false;
                object.oldRBCOPImageFile = null;

                object.setEditedProp('CutoutFace');
                object.setEditedProp('removeBackgroundCOP');

                $scope.showApiKeyInput.cutoutPro = false;
                return;
            }

            if (isFaceCutout) {
                object.CutoutFace = targetProperties.CutoutFace;
                object.oldRBCOPImageFile = null;
            } else {
                object.removeBackgroundCOP = targetProperties.removeBackgroundCOP;
                object.oldCutoutImageFile = null;
            }

            if (editMode) {
                if (isFaceCutout) {
                    object.setEditedProp('CutoutFace');
                } else {
                    object.setEditedProp('removeBackgroundCOP');
                }
            }

            $scope.previousFilterImageFile = [];

            // Next line means that an image was previously used. If that's the case reusing it from file and avoid API call.
            if (
                !object.oldCutoutImageFile &&
                !object.oldRBCOPImageFile &&
                (object.CutoutFace || object.removeBackgroundCOP)
            ) {
                if (!$scope.apiKeys.cutoutPro) {
                    $scope.showApiKeyInput.cutoutPro = true;
                    $timeout(function () {
                        $scope.$apply();
                    });
                    return;
                } else {
                    if (object.imageFile) await faceCutout($scope, canvas, isFaceCutout, true);
                }
            } else if (object.oldCutoutImageFile) {
                // If does not have an oldCutoutImageFile it is useless to swap.
                MultipleFileUploadService.uploadMultipleImages($scope, canvas, [object.oldCutoutImageFile], object);
                // Swap between with and without background
                const aux = object.oldCutoutImageFile;
                object.oldCutoutImageFile = object.imageFile;
                object.imageFile = aux;
            } else if (object.oldRBCOPImageFile) {
                // If does not have an oldCutoutImageFile it is useless to swap.
                MultipleFileUploadService.uploadMultipleImages($scope, canvas, [object.oldRBCOPImageFile], object);
                // Swap between with and without background
                const aux = object.oldRBCOPImageFile;
                object.oldRBCOPImageFile = object.imageFile;
                object.imageFile = aux;
            }

            if (!object.CutoutFace) {
                $timeout(() => $scope.$apply());
                $scope.showApiKeyInput.cutoutPro = false;
            }

            if (!object.removeBackgroundCOP) {
                $timeout(() => $scope.$apply());
                $scope.showApiKeyInput.cutoutPro = false;
            }
        }

        return {
            faceCutout: faceCutout,
            addFaceCutoutFilter: addFaceCutoutFilter
        };
    }
})();
